import { render, staticRenderFns } from "./metarialCenter.vue?vue&type=template&id=4e36edc3"
import script from "./metarialCenter.vue?vue&type=script&lang=js"
export * from "./metarialCenter.vue?vue&type=script&lang=js"
import style0 from "./metarialCenter.vue?vue&type=style&index=0&id=4e36edc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports